export const createDate = (date: number | string): string => {
    const createdDate = new Date(date);
    const day = createdDate.getDate() < 10 ? '0' + createdDate.getDate() : createdDate.getDate();
    const month = createdDate.getMonth() + 1 < 10 ? '0' + (createdDate.getMonth() + 1) : createdDate.getMonth() + 1;
    return `${day}.${month}.${createdDate?.getFullYear()}`;
};
